export function validate(obj, _value) {
  var _obj$props = obj.props,
      validators = _obj$props.validators,
      customValidator = _obj$props.customValidator,
      errorMessages = _obj$props.errorMessages;
  var isValid = true; // Validate with custom validators first

  if (customValidator !== undefined) {
    var message = customValidator(_value);

    if (message !== undefined) {
      obj.setState({
        errorMessage: message,
        isValid: false
      });
      isValid = false;
      return isValid;
    } else {
      obj.setState({
        errorMessage: undefined,
        isValid: true
      });
      isValid = true;
    }
  } // Validate with predefined validators


  if (validators !== undefined) {
    var _message = undefined;

    for (var i = 0; i < validators.length; i++) {
      var _err = undefined;

      if (errorMessages && errorMessages.length > i) {
        _err = errorMessages[i];
      }

      _message = validationFunctions[validators[i]](_value, _err);

      if (_message) {
        break;
      }
    }

    obj.setState({
      isValid: _message === undefined,
      errorMessage: _message
    });
    isValid = _message === undefined;
  }

  return isValid;
}
;
export var validationFunctions = {
  isTrue: function isTrue(value, message) {
    return value !== true ? message : undefined;
  },
  required: function required(value) {
    return value === undefined || value === '' ? 'The field is required' : undefined;
  },
  email: function email(value) {
    var re = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;

    if (!re.test(value.toLowerCase())) {
      return 'Not a valid email';
    }
  },
  phone: function phone(value) {
    var re = /\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{3})/;

    if (!re.test(value)) {
      return 'Not a valid phone';
    }
  }
};